import React, {  } from 'react';

import { relativeTimeFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { RelativeTimeFormatInput } from './Intl.RelativeTimeFormat';

export const IntlRelativeTimeFormatFormat = () => (
	<IntlFunction
		input={RelativeTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/format"
		header="Intl.RelativeTimeFormat.prototype.format"
		description="Formats a **`value`** and **`unit`** according to the locale and formatting options of this [Intl.RelativeTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat) object."
		options={relativeTimeFormatOptions}
		ruleSet={[]}
		template="new Intl.RelativeTimeFormat(##locale##, ##options##).format(##input:raw##, ##input##)" />
)